// I am user npm install lightpick here

import Lightpick from 'lightpick';

// Styles
import 'lightpick/css/lightpick.css';

// We also need momentjs for lightpick
import moment from 'moment';
import 'moment/locale/fr';

export default function initLightpick() {
    if (!document.querySelector('.date-calendar-zone')) {
        return;
    }

    const lightpickLang = document.documentElement.lang === 'en-CA' ? 'en' : 'fr';

    if (lightpickLang === 'en') {
        moment.locale('en');
    } else {
        moment.locale('fr');
    }

    const triggerBtn = document.querySelector('[data-toggle-modal="modal-dates"]');

    if (!triggerBtn) {
        return;
    }

    document.body.addEventListener('click', (e) => {
        if (!e.target.closest('[data-toggle-modal="modal-dates"]')) {
            return;
        }

        const btnEl = e.target.closest('[data-toggle-modal="modal-dates"]');

        if (btnEl.classList.contains('has-been-triggered')) {
            return;
        }

        btnEl.classList.add('has-been-triggered');

        let localeTooltip = {
            one: 'jour',
            few: 'jours',
            many: 'jours',
            other: 'jours',
        };

        if (lightpickLang === 'en') {
            localeTooltip = {
                one: 'day',
                few: 'days',
                many: 'days',
                other: 'days',
            };
        }

        new Lightpick({
            field: document.getElementById('datepicker'),
            secondField: document.getElementById('datepicker_end'),
            singleDate: false,
            firstDay: 7,
            lang: lightpickLang,
            format: 'YYYY-MM-DD',
            autoclose: true,
            minDate: moment().startOf('day'),
            maxDate: moment().add(12, 'months').endOf('day'),
            selectForward: true,
            selectBackward: false,
            maxDays: 60,
            hoveringTooltip: true,
            inline: true,
            parentEl: document.querySelector('.date-calendar-zone'),
            dropdowns: false,
            locale: {
                tooltip: localeTooltip,
            },
        });
    });
}
